
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        {/* Company Info - 獨立一行 */}
        <div className="mb-10">
          <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">房仲契約書購買平台</h3>
          <p className="text-sm sm:text-base text-gray-300 leading-relaxed max-w-2xl">
            提供專業的<strong>房仲契約書購買</strong>與<strong>契約書訂購</strong>服務，涵蓋土地買賣、土地租賃、房屋買賣、房屋租賃等各類需求，協助您快速完成交易文件準備。訂購後立即出貨。
          </p>
        </div>

        {/* 三欄並排 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12">
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#d4af37]">契約書購買類型</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contracts?category=sales-commission" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  銷售委託類契約書購買
                </Link>
              </li>
              <li>
                <Link to="/contracts?category=lease-commission" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  租賃委託契約書訂購
                </Link>
              </li>
              <li>
                <Link to="/contracts?category=sale-contract" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  買賣契約書購買
                </Link>
              </li>
              <li>
                <Link to="/contracts?category=property-disclosure" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  不動產說明文件訂購
                </Link>
              </li>
              <li>
                <Link to="/contracts?category=buyer-documents" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  買方文件購買
                </Link>
              </li>
              <li>
                <Link to="/contracts?category=payment-documents" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  收款文件訂購
                </Link>
              </li>
              <li>
                <Link to="/contracts?category=registration-documents" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  地政士文件購買
                </Link>
              </li>
              <li>
                <Link to="/contracts?category=others" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  其他契約書訂購
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-[#d4af37]">客戶服務</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  常見問題
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  聯絡我們
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-[#d4af37]">聯絡資訊</h3>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-[#d4af37] mt-0.5"></i>
                <div>
                  <div>04-35023788</div>
                  <div className="text-xs text-gray-400 mt-1">傳真：04-22475540</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-line-fill text-[#d4af37] mt-0.5"></i>
                <div>
                  <div>楊小姐</div>
                  <div className="text-xs text-gray-400 mt-1">LINE ID: ivanok88</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#d4af37] mt-0.5"></i>
                <span>台中市北屯區崇德二路二段8號</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-[#d4af37] mt-0.5"></i>
                <span>週一至週五 09:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10">
          <div className="max-w-7xl mx-auto px-6 py-6">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-gray-400 text-sm">
                © {currentYear} 契約書範本專家. All rights reserved.
              </p>
              
              <div className="flex items-center gap-6">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-gray-400 flex items-center justify-center text-gray-400 hover:border-[#d4af37] hover:text-[#d4af37] transition-all duration-300 cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="https://line.me" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-gray-400 flex items-center justify-center text-gray-400 hover:border-[#d4af37] hover:text-[#d4af37] transition-all duration-300 cursor-pointer">
                  <i className="ri-line-fill text-lg"></i>
                </a>
                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-gray-400 flex items-center justify-center text-gray-400 hover:border-[#d4af37] hover:text-[#d4af37] transition-all duration-300 cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>

              <div className="flex items-center gap-4 text-sm">
                <a href="#" className="text-gray-400 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  隱私權政策
                </a>
                <span className="text-gray-600">|</span>
                <a href="#" className="text-gray-400 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  服務條款
                </a>
                <span className="text-gray-600">|</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer">
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
